import { render } from "./CreateJob.vue?vue&type=template&id=00f07d95&ts=true"
import script from "./CreateJob.vue?vue&type=script&lang=ts"
export * from "./CreateJob.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__